import * as z from "zod";

export const updateOnboardingV2DealSize = {
  name: "updateOnboardingV2DealSize" as const,
  input: z.object({
    teamId: z.string().min(1),
    productId: z.string().min(1),
    dealSize: z.number().nullable(),
  }),
  output: z.object({ success: z.boolean() }),
};

export type UpdateOnboardingV2DealSizeInput = z.infer<
  typeof updateOnboardingV2DealSize.input
>;
export type UpdateOnboardingV2DealSizeOutput = z.infer<
  typeof updateOnboardingV2DealSize.output
>;
